<template>
    <div class="upload-btn" style="display: inline-block">
        <el-upload
            :action="action"
            style="display: inline-block"
            :headers="headers"
            :data="edata"
            name="upload"
            :show-file-list="false"
            :on-success="fileSuccess"
            :on-error="fileError"
            :before-upload="beforeUpload">
            <slot />
        </el-upload>

        
		<el-dialog title="导入结果" :close-on-click-modal="false" width="800px" :visible.sync="importDialog" append-to-body @close="reInit">
            <div class="error-msg" v-if="errorMsg">{{errorMsg}}</div>
            <div class="error-box" v-if="importDialog && importExcel">
                <div class="success-box" v-if="importExcel.status == 1">
                    <div class="text">文件【{{importExcel.fileName}}】导入成功！</div>
                </div>
                <div class="error-box" v-if="importExcel.status == 2">
                    <div class="text text-red">文件【{{importExcel.fileName}}】导入失败！</div>
                    <div class="table-box">
                        <div class="line-box" v-for="(c,i) in importExcel.importExcelErrorLineList" :key="i">{{c.intro}}</div>
                    </div>
                </div>
            </div>
		</el-dialog>
    </div>
</template>
<script>
import { Loading } from 'element-ui';
export default {
    props: {
        text: {
            type: String,
            default: '上传Excel'
        },
        size: {
            type: String,
            default: 'mini'
        },
        edata: {
            type: Object,
            default: null
        }
    },
    data(){
        return {
            action: '',
            headers: {},

            importExcel: '',
            importDialog: false,
            loadingObj: null,

            errorMsg: '',
        }
    },
    mounted(){
        this.init()
    },
    methods: {
        init(){
            this.action = this.$config.baseUrl + '/api/school/import/excel';
            let authToken = this.$util.cacheGet("authTokenSchool");
            this.headers = {'Authorization': authToken};
        },
        reInit(){
            this.importExcel = ''
            this.loadingObj = null
            this.errorMsg = ''
        },
        fileSuccess(res, file) {
            // 导入成功
            if(this.loadingObj){
                this.loadingObj.close();
            }
            if(res.status == 0){
                this.errorMsg = res.msg
                if(this.edata.type == 'refundApply'){
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            }
            let importExcel = res.data
            if(this.edata.type != 'refundApply'){
                this.importDialog = true
            }
            if(importExcel.id){
                this.getInfo(importExcel)
            }else{
                this.$emit("success", res.data)
            }
        },
        fileError(){
            if(this.loadingObj){
                this.loadingObj.close();
            }
            this.$message({
                message: '上传失败！请重新上传',
                type: 'error'
            })
        },
        beforeUpload(file){
            this.loadingObj = Loading.service({
                lock: true,
                text: '正在上传',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.6)'
            });
        },
        async getInfo(importExcel){
            let res = await this.$api.rGet('import/excel/' + importExcel.id, {}, true)
            if(res.status == 1){
                this.importExcel = res.data
                
                if(res.data.status == 1){
                    this.$emit('success')
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .error-msg{
        color: red;
        padding-bottom: 10px;
    }
    .table-box{
        margin-top: 20px;
        .line-box{
            padding: 10px;
            border: 1px solid #ccc;
            border-bottom: 0;
            &:last-child{
                border-bottom: 1px solid #ccc;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ImportFile.vue